import React from 'react'
import { AlertBanner, Section } from '@chilipiper/design-system/src/new'
import { useTranslations } from '../../../context/TranslationContext'
import { formatDate } from './DisplayDate'

type Props = {
  date: { end: string; start: string }
  timezone: string
}

export const PreviousSchedule = ({ date, timezone }: Props) => {
  const [youAreRescheduling, yourCurrentlyScheduledMeetingIsOn, chooseANewTimeBelow] =
    useTranslations([
      'youAreRescheduling',
      'yourCurrentlyScheduledMeetingIsOn',
      'chooseANewTimeBelow',
    ])
  const description = `${yourCurrentlyScheduledMeetingIsOn ?? 'Your currently scheduled meeting is on'} ${formatDate(date, timezone)}. ${chooseANewTimeBelow ?? 'Choose a new time below.'}`
  return (
    <Section>
      <AlertBanner
        variant='inform'
        title={youAreRescheduling ?? "You're rescheduling"}
        description={description}
      />
    </Section>
  )
}
